<template>
  <div class="containerSearchDirection">
    <el-row :gutter="20" class="rowComponentOfDirection">
      <el-col :span="24">
        <DistritoTypeAhead
          ref="inputDistrito"
          @selectDistrito="distritoSelected"
          @cleanDistrictEmittion="cleanComponentsOfDirectionByDistrito"
        ></DistritoTypeAhead>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="rowComponentOfDirection">
      <el-col :span="24">
        <ViaTypeahead
          ref="inputVia"
          @eventSelectVia="selectVia"
          @cleanViaEmittion="cleanComponentsOfDirectionByVia"
        ></ViaTypeahead>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="rowComponentOfDirection rowNumberDirection">
      <el-col :span="24">
        <div class="inner-addon right-addon">
          <i class="uil uil-search glyphicon iconInput" v-show="isEmptyNumber"></i>
          <i
            class="uil uil-times glyphicon iconInput"
            style="cursor: pointer"
            v-show="isDirtyNumber"
            @click="cleanInputNumber"
          ></i>
          <vs-input
            type="number"
            class="inputNumberDirection"
            placeholder="Numero de domicilio"
            ref="refInputNumberVia"
            v-model="numberDirection"
            @keydown.enter="searchDirection"
          />
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="rowComponentOfDirection">
      <el-col :span="24">
        <NucleoUrbano
          ref="inputNucleoUrbano"
          @eventSelectNucleoUrbano="nucleoUrbanoSelected"
          @cleanNucleoUrbanoEmittion="cleanComponentsOfDirectionByNucleoUrbano"
        ></NucleoUrbano>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="rowComponentOfDirection">
      <el-col :span="24">
        <div class="inner-addon right-addon">
          <i class="uil uil-search glyphicon iconInput" v-show="isEmptyManzana"></i>
          <i
            class="uil uil-times glyphicon iconInput"
            style="cursor: pointer"
            v-show="isDirtyManzana"
            @click="cleanInputManzana"
          ></i>
          <vs-input
            ref="refInputManzana"
            class="inputManzana"
            placeholder="Manzana"
            v-model="manzanaDirection"
            @keydown.enter="searchDirection"
          />
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="rowComponentOfDirection">
      <el-col :span="24">
        <div v-if="nivel_search" :class="classForPrecision">
          <label>{{ nivel_search }}</label>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="rowComponentOfDirection">
      <el-col :span="24">
        <el-button class="btnSearchDirection" type="success" @click="searchDirection"
          >Buscar</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>

<script>
import DistritoTypeAhead from "./DistritoTypeAhead";
import ViaTypeahead from "./ViaTypeAhead";
import NucleoUrbano from "./NucleoUrbanoTypeAhead";
import axios from "axios";
import { mapState } from "vuex";

export default {
  name: "SearchDirectionSedapar",
  components: { DistritoTypeAhead, ViaTypeahead, NucleoUrbano },

  data() {
    return {
      numberDirection: "",
      manzanaDirection: "",
      urlBase: "",
      nivel_search: "",
      classForPrecision: "",
    };
  },

  created() {
    this.urlBase = process.env.VUE_APP_GEOCODING;
  },

  mounted() {
    this.$refs["inputDistrito"].$el.focus();
    this.$refs["refInputNumberVia"].$el.querySelector("input").value = "";
    // Si se viene desde la vista de Claro, limpia los edificios que hayan quedado en el mapa
    this.removeLayers();
  },

  computed: {
    ...mapState(["map", "user"]),
    isEmptyNumber() {
      return this.numberDirection === "";
    },
    isDirtyNumber() {
      return !!this.numberDirection;
    },
    isEmptyManzana() {
      return this.manzanaDirection === "";
    },
    isDirtyManzana() {
      return !!this.manzanaDirection;
    },
  },

  methods: {
    cleanInputNumber() {
      this.numberDirection = "";
      this.$refs["refInputNumberVia"].$el.querySelector("input").focus();
    },
    cleanInputManzana() {
      this.manzanaDirection = "";
      this.$refs["refInputManzana"].$el.querySelector("input").focus();
    },
    distritoSelected() {
      this.$refs["inputVia"].$el.querySelector("input").focus();
    },
    nucleoUrbanoSelected() {
      this.$refs["refInputManzana"].$el.querySelector("input").focus();
    },
    selectVia() {
      const input = this.$refs["refInputNumberVia"].$el.querySelector("input");
      input.value = "";
      input.focus();
    },

    cleanComponentsOfDirectionByDistrito() {
      this.$store.commit("store_setUbigeo", "");
      this.$refs["inputVia"].data = "";
      this.$store.commit("SET_TIPO_VIA_DIRECTION", 0);
      this.$store.commit("SET_VIA_DIRECTION", "");
      this.$refs["inputNucleoUrbano"].data = "";
      this.$store.commit("SET_TIPO_NU_DIRECTION", 0);
      this.$store.commit("SET_NU_DIRECTION", "");
      this.numberDirection = "";
      this.manzanaDirection = "";
      this.nivel_search = "";
    },
    cleanComponentsOfDirectionByVia() {
      this.$store.commit("SET_TIPO_VIA_DIRECTION", 0);
      this.$store.commit("SET_VIA_DIRECTION", "");
      this.$refs["inputNucleoUrbano"].data = "";
      this.$store.commit("SET_TIPO_NU_DIRECTION", 0);
      this.$store.commit("SET_NU_DIRECTION", "");
      this.numberDirection = "";
      this.manzanaDirection = "";
      this.nivel_search = "";
    },
    cleanComponentsOfDirectionByNucleoUrbano() {
      this.manzanaDirection = "";
    },

    removeLayers() {
      if (!this.map) return;
      const marker = this.$store.getters.layerMarkerSearcher;
      if (marker) this.map.removeLayer(marker);
      const buildings = this.$store.getters.layerMarkerBuildingsSearcher;
      if (buildings) this.map.removeLayer(buildings);
    },

    buildAddress() {
      const via = this.$store.getters.via;
      const tipoVia = this.$store.getters.tipoVia;
      const nu = this.$store.getters.nucleoUrbano;
      const tipoNu = this.$store.getters.tipoNucleoUrbano;

      const partes = [];
      if (via) partes.push(tipoVia ? `${tipoVia} ${via}` : via);
      if (this.numberDirection) partes.push(`nro ${this.numberDirection}`);
      if (nu) partes.push(tipoNu ? `${tipoNu} ${nu}` : `urb ${nu}`);
      if (this.manzanaDirection) partes.push(`mzn ${this.manzanaDirection}`);
      return partes.join(" ").trim();
    },

    searchDirection() {
      this.removeLayers();

      const ubigeo = this.$store.getters.ubigeo;
      if (!ubigeo) {
        this.$notify({
          title: "Aviso",
          message: "Seleccione un distrito e ingrese una dirección",
          type: "warning",
        });
        return;
      }

      const email = this.user && this.user.email ? this.user.email : "";
      const url =
        `${this.urlBase}address=${encodeURIComponent(this.buildAddress())}` +
        `&segments=locality_id:${ubigeo}&maps=true&mapsaccount=${email}`;

      axios
        .get(url)
        .then((response) => this.showResult(response.data))
        .catch((error) => console.log(error));
    },

    showResult(result) {
      if (!result || result.status !== "OK" || !result.results || !result.results.length) {
        this.$notify({
          title: "Aviso",
          message: "No se encontró la dirección",
          type: "warning",
        });
        return;
      }

      const first = result.results[0];
      const coords = first.geometry.coordinates;

      this.$store.commit("SET_LATITUD_GENERAL", coords.lat);
      this.$store.commit("SET_LONGITUD_GENERAL", coords.lon);

      this.evaluatePrecision(first.geometry.geocoding_type, first.result_types || []);

      const latlng = L.GeoJSON.coordsToLatLng([coords.lon, coords.lat]);
      this.map.setView(latlng, 18, { duration: 1 });

      const icon = new L.Icon({
        iconUrl: require("../../assets/images/icon_marker.png"),
        iconAnchor: [12, 30],
      });

      const marker = L.marker(latlng, { icon })
        .addTo(this.map)
        .bindPopup(first.standard_address)
        .openPopup();

      this.$store.commit("SET_LAYER_MARKER", marker);
      this.$store.commit("SET_PLACE_ID", first.place_id);
      this.$store.commit("SET_ADDRESS", first.standard_address);
    },

    evaluatePrecision(tipo, detalle) {
      if (tipo === "DOOR" || tipo === "INTERPOLATED") {
        this.classForPrecision = "precision-alta";
        this.nivel_search = "Precisión Alta";
      } else if (
        tipo === "CENTER" &&
        (detalle.includes("route") || detalle.includes("sublocality"))
      ) {
        this.classForPrecision = "precision-media";
        this.nivel_search = "Precisión Media";
      } else {
        this.classForPrecision = "precision-baja";
        this.nivel_search = "Precisión Baja";
      }
    },
  },
};
</script>

<style>
.containerSearchDirection {
  margin: 5px 10px;
}
.rowComponentOfDirection {
  margin-top: 12px;
}
.btnSearchDirection {
  width: 100%;
  border-radius: 2px !important;
}
.inputNumberDirection,
.inputManzana {
  width: 100% !important;
  color: #5c5c5c;
  font-size: 14px;
}
.inputNumberDirection .vs-input-number--input {
  min-width: 100px !important;
  background: white !important;
}
.inner-addon {
  position: relative;
}
.inner-addon .glyphicon {
  position: absolute;
  padding: 6px;
}
.right-addon .glyphicon {
  right: 0px;
}
.right-addon input {
  padding-right: 30px;
}
.iconInput {
  z-index: 2;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.precision-alta {
  padding: 5px 5px 5px 0px;
  color: #009700;
  font-size: 13px;
  text-align: center;
  border-bottom: #009700 1px solid;
}
.precision-media {
  padding: 5px 5px 5px 0px;
  color: #e69500;
  font-size: 13px;
  text-align: center;
  border-bottom: #e69500 1px solid;
}
.precision-baja {
  padding: 5px 5px 5px 0px;
  color: #0080ff;
  font-size: 13px;
  text-align: center;
  border-bottom: #0080ff 1px solid;
}
</style>